import BackgroundLeft from './BackgroundLeft';
import BackgroundRight from './BackgroundRight';
import Billboard from './Billboard';
import Button from './Button';
import Leaderboard from './Leaderboard';
import Panorama from './Panorama';
import Wideskyscrapper from './Wideskyscrapper';

const ads = {
  BackgroundLeft,
  BackgroundRight,
  Billboard,
  Button,
  Leaderboard,
  Panorama,
  Wideskyscrapper,
};

export default ads;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/index.js
 **/